import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FlujosPaso2PJService } from 'src/app/global/services/flujos-paso-2-pj.service';
import { UafService } from 'src/app/global/services/uaf.service';

@Component({
  selector: 'app-declaracion-jurada',
  templateUrl: './declaracion-jurada.component.html',
  styleUrls: ['./declaracion-jurada.component.scss']
})
export class DeclaracionJuradaComponent {
  constructor(
    private router: Router,
    private  uafService: UafService,
    private flujosPaso2PJServ: FlujosPaso2PJService,

  ) { }

  @Output() paso4Ok: EventEmitter<any> = new EventEmitter();

  init() {
    this.uafService.validaDeclaracionUaf().subscribe((response: any ) => {
      this.flujosPaso2PJServ.formularioUAF.cargando = false;
      this.flujosPaso2PJServ.formularioUAF.bloqueado = false;

      if (response.data) {
        this.paso4Ok.emit();
      }
      this.flujosPaso2PJServ.formularioUAF.ok = response.data;
    });
  }

  get flujo() {
    return this.flujosPaso2PJServ.formularioUAF;
  }

  redireccionarFormulatioUaf() {
    this.router.navigate(['/formulario-uaf']);
  }
}
